import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant'; //

//
export interface CreationRequest {
  mobile?: string;
  password?: string;
  id_card?: string;
  is_captain?: number;
  real_name?: string;
  name?: string;
  status?: number;
  auth_status?: number;
  pid?: number;
}

export interface CreateResponse extends Response {
  data: null;
}

//
export const creation = (data: CreationRequest): Promise<CreateResponse> => {
  return axios.post(Urls.createUrl, data);
};

//
type UseCreateOptions = {
  config?: MutationConfig<typeof creation>;
};

export const useCreate = ({ config }: UseCreateOptions = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: creation,
    ...config,
  });
};
